import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetFeeTemplatesQuery = ({
	companyId,
	isActive,
}: {
	companyId: string;
	isActive?: boolean;
}) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["feeTemplates"],
		() =>
			agentOfficeSetupService.getFeeTemplates(
				companyId,
				"Fees",
				isActive,
			),
		{
			select: (
				data: {
					id: string;
					name: string;
				}[],
			) => {
				return data?.map(template => ({
					id: template.id,
					name: template.name,
				}));
			},

			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.title,
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
			enabled: !!companyId,
		},
	);

	return queryResult;
};

export default useGetFeeTemplatesQuery;
